/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { TeamModelDto } from '../../models/team-model-dto';

export interface UserControllerUpdateTeam$Params {
  uuid: string;
      body: TeamModelDto
}

export function userControllerUpdateTeam(http: HttpClient, rootUrl: string, params: UserControllerUpdateTeam$Params, context?: HttpContext): Observable<StrictHttpResponse<TeamModelDto>> {
  const rb = new RequestBuilder(rootUrl, userControllerUpdateTeam.PATH, 'put');
  if (params) {
    rb.path('uuid', params.uuid, {});
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<TeamModelDto>;
    })
  );
}

userControllerUpdateTeam.PATH = '/user/teams/{uuid}';
